<template>
  <div class="flex flex-col items-center justify-center 2xl:h-[410px] lg:h-[350px] md:h-[320px] h-[200px] animation animate-pulse bg-dark-100">
    <div class="w-2/3 h-8 max-w-md rounded-md bg-dark-50" />
    <div class="w-10/12 h-4 max-w-lg mt-4 rounded-md bg-dark-50" />
  </div>
</template>

<script setup lang="ts" />
